import React from 'react';
import {NavBar} from './common/NavBar';
import styles from './DefaultLayout.module.scss';
//import SideBar from './common/SideBar';
//import {ListItem, Tooltip, ListItemIcon} from '@mui/material';
//import ZoomInIcon from '@mui/icons-material/ZoomIn';
//import ZoomOutIcon from '@mui/icons-material/ZoomOut';
//import ZoomResetIcon from '@mui/icons-material/AspectRatio';
import SnackbarContainer from './common/SnackbarContainer';
import clsx from 'clsx';

import {ThemeType} from '../../styles';
//import {useZoom} from '../../hooks/useZoom';
//import {useLocalStorage} from '../../hooks/useLocalStorage';
//import {useDispatch} from 'react-redux';
//import {appSetZoom} from '../../store/app';

export type LayoutProps = {
  component: React.FC<any>;
  theme?: ThemeType;
  className?: string;
};

// type LeftSidebarItemProps = {
//   text: string;
//   icon: React.ReactElement;
//   disabled?: boolean;
//   onClick: () => void;
// };

// const LeftSidebarItem: React.FC<LeftSidebarItemProps> = ({text, icon, ...listItemProps}) => (
//   <ListItem disableGutters {...listItemProps}>
//     <Tooltip title={text}>
//       <ListItemIcon>{icon}</ListItemIcon>
//     </Tooltip>
//   </ListItem>
// );
const DefaultLayout: React.FC<LayoutProps> = ({component: Component, theme = 'whiteTheme', className}) => {
  // const dispatch = useDispatch();
  // const [storedZoom, setStoredZoom] = useLocalStorage('zoom', 1);
  // const {zoom, zoomIn, zoomOut, zoomReset, isDefault, isMin, isMax} = useZoom(storedZoom, 1, 0.1, 0.7, 1.1);
  // useEffect(() => {
  //   setStoredZoom(zoom);
  //   dispatch(appSetZoom(zoom));
  // }, [zoom, setStoredZoom, dispatch]);

  // const currentPath = window.location.hash;
  // const pathsToSkip = ['#/model', '#/filter'];

  return (
    <div className={clsx('layoutWrapper', styles.wrapper, className)}>
      <NavBar />

      <div className={clsx(styles.container, theme)}>
        {/* {!pathsToSkip.includes(currentPath) && (
          <SideBar className={clsx('noPrint', styles.leftSideBar)} theme="darkTheme">
            <List dense component="nav">
              <LeftSidebarItem text="Zoom in" disabled={isMax} onClick={zoomIn} icon={<ZoomInIcon />} />
              <LeftSidebarItem text="Zoom out" disabled={isMin} onClick={zoomOut} icon={<ZoomOutIcon />} />
              <LeftSidebarItem text="Reset zoom" disabled={isDefault} onClick={zoomReset} icon={<ZoomResetIcon />} />
            </List>
          </SideBar>
        )} */}
        <div className={styles.container} style={{flexDirection: 'column', height: 'auto'}}>
          <div id="secondaryNav-portal"></div>
          <div className={styles.container}>
            <Component />
          </div>
        </div>
      </div>
      <SnackbarContainer />
    </div>
  );
};

export default DefaultLayout;
